import React, { useEffect, useState } from "react";
import "./App.css";
import {
  BrowserRouter as Router,
  Route,
  Navigate,
  Routes,
} from "react-router-dom";
import NavbarDoctors from "./shared/pages/NavbarDoctors";
import Navbar from "./shared/pages/Navbar";
import styled from "@emotion/styled";

import { Box } from "@mui/system";
import NewOrderForm from "./orders/pages/NewOrderForm";
import ExitOrder from "./orders/pages/ExitOrder";
import EnterOrder from "./orders/pages/EnterOrder";
import OrdersView from "./orders/pages/OrdersView";
import OrderDetails from "./orders/pages/OrderDetails";
import ReceiptsContainer from "./receipts/pages/ReceiptsContainer";

import { AuthContext } from "./context/AuthContext";
import useAuth from "./shared/hooks/auth-hooks";
import DoctorsPage from "./doctorsPanel/DoctorsPage";
import Login from "./users/pages/Login";
import Register from "./users/pages/Register";
import OrderTypes from "./orderTypes/pages/OrderTypes";
import OrderProcesses from "./orderProcesses/pages/OrderProcesses";
import DoctorsContainer from "./doctors/pages/DoctorsContainer";
import DoctorDetails from "./doctors/components/DoctorDetails";
import ReceiptsView from "./receipts/pages/ReceiptsView";
import ReceiptDetails from "./receipts/pages/ReceiptDetails";
import OrdersViewDoctors from "./doctorsPanel/orders/pages/OrdersViewDoctors";
import OrderDetailsDoctors from "./doctorsPanel/orders/pages/OrderDetailsDoctors";
import Planning from "./planning/pages/Planning";
import Dashboard from "./dashboard/pages/Dashboard";
import ReceiptsViewDoctors from "./doctorsPanel/receipts/pages/ReceiptsViewDoctors";
import ReceiptsDetailsDoctors from "./doctorsPanel/receipts/pages/ReceiptsDetailsDoctors";
import UserInfo from "./users/pages/UserInfo";
import ResetPassword from "./users/pages/ResetPassword";

const Routing = (props) => {
  const { token, login, type, name, logout } = useAuth();
  let routes;
  if (token) {
    if (type === "laboratory") {
      routes = (
        <React.Fragment>
          <Router>
            <Navbar modeHandler={props.modeHandler} mode={props.mode} />
            <Box
              sx={{
                my: {
                  xs: "calc(56px + 3%)",
                  md: "calc(64px + 3%)",
                },
                ml: {
                  xs: "calc(57px + 3%)",
                  md: "calc(65px + 3%)",
                },
                mr: { xs: "3%", md: "3%" },
              }}
            >
              <div className="main">
                <Routes>
                  <Route
                    path="/lab/orders/newOrder"
                    exact
                    element={<NewOrderForm />}
                  />
                  {/* <Route path="/lab/orders/submitEntrance" exact /> */}
                  <Route
                    path="/lab/orders/submitExit"
                    exact
                    element={<ExitOrder />}
                  />
                  <Route
                    path="/lab/orders/submitEntrance"
                    exact
                    element={<EnterOrder />}
                  />

                  <Route
                    path="/lab/orders/view"
                    exact
                    element={<OrdersView />}
                  />
                  <Route
                    path="/lab/orders/view/:oId"
                    exact
                    element={<OrderDetails />}
                  />
                  <Route
                    path="/lab/management/planning"
                    exact
                    element={<Planning />}
                  />
                  <Route
                    path="/lab/management/dashboard"
                    exact
                    element={<Dashboard />}
                  />
                  <Route
                    path="/lab/receipts/submit"
                    exact
                    element={<ReceiptsContainer />}
                  />
                  <Route
                    path="/lab/receipts/view"
                    exact
                    element={<ReceiptsView />}
                  />
                  <Route
                    path="/lab/receipts/view/:rId"
                    exact
                    element={<ReceiptDetails />}
                  />
                  <Route
                    path="/lab/defaults/doctors"
                    element={<DoctorsContainer />}
                    exact
                  />
                  <Route
                    path="/lab/defaults/doctors/:dId"
                    exact
                    element={<DoctorDetails />}
                  />

                  <Route
                    path="/lab/defaults/processes"
                    element={<OrderProcesses />}
                    exact
                  />
                  <Route
                    path="/lab/defaults/orderTypes"
                    element={<OrderTypes />}
                    exact
                  />
                  <Route
                    path="/lab/defaults/userInfo"
                    element={<UserInfo />}
                    exact
                  />
                  <Route
                    path="/login"
                    element={
                      <Navigate replace={true} to="/lab/orders/newOrder" />
                    }
                  ></Route>
                </Routes>
              </div>
            </Box>
          </Router>
        </React.Fragment>
      );
    } else {
      routes = (
        <React.Fragment>
          <Router>
            <NavbarDoctors modeHandler={props.modeHandler} mode={props.mode} />
            <Box
              sx={{
                my: {
                  xs: "calc(56px + 3%)",
                  md: "calc(64px + 3%)",
                },
                ml: {
                  xs: "calc(57px + 3%)",
                  md: "calc(65px + 3%)",
                },
                mr: { xs: "3%", md: "3%" },
              }}
            >
              <div className="main">
                <Routes>
                  <Route
                    path="/clinic/orders"
                    exact
                    element={<OrdersViewDoctors />}
                  />
                  <Route
                    path="/clinic/orders/:oId"
                    exact
                    element={<OrderDetailsDoctors />}
                  />
                  <Route
                    path="/clinic/receipts"
                    exact
                    element={<ReceiptsViewDoctors />}
                  />
                  <Route
                    path="/clinic/receipts/:rId"
                    exact
                    element={<ReceiptsDetailsDoctors />}
                  />
                  <Route
                    path="/clinic/defaults/userInfo"
                    element={<UserInfo />}
                    exact
                  />

                  <Route
                    path="/"
                    element={<Navigate replace={true} to="/clinic/orders" />}
                  />
                  <Route
                    path="/login"
                    element={<Navigate replace={true} to="/clinic/orders" />}
                  />
                </Routes>
              </div>
            </Box>
          </Router>
        </React.Fragment>
      );
    }
  } else {
    routes = (
      <React.Fragment>
        <Router>
          <Box sx={{ mt: { sm: "5.5%", md: "5.5%" } }}>
            <div className="main">
              <Routes>
                <Route path="/login" exact element={<Login />} />
                <Route path="/register" exact element={<Register />} />
                <Route path="/reset-password" element={<ResetPassword />} />
                <Route
                  path="/"
                  element={<Navigate replace={true} to="/login" />}
                />
              </Routes>
            </div>
          </Box>
        </Router>
      </React.Fragment>
    );
  }
  return (
    <div>
      <AuthContext.Provider
        value={{
          isLoggedIn: !!token,
          token: token,
          login: login,
          logout: logout,
          type: type,
          name: name,
        }}
      >
        {routes}
      </AuthContext.Provider>
    </div>
  );
};

export default Routing;
